import { BuyToneDto } from '../../../../core/dto/buytone/buytonedto';
import { APIModel, APIModelImpl, APIModelHandler } from '../../../toolkit/uicomponentapimodel';
import { BuyToneResponse } from '../../../../core/api/tune/buytune/buytoneresponse';
import { BuyToneRequestImpl } from '../../../../core/api/tune/buytune/buytonerequest';
import { GetTonePriceResponse } from '../../../../core/api/tune/gettuneprice/gettonepriceresponse';
import { GetTonePriceRequestImpl } from '../../../../core/api/tune/gettuneprice/gettonepricerequest';
import { GetTonePriceDtoImpl } from '../../../../core/dto/gettoneprice/gettonepricedto';
import { ToneDto } from '../../../../core/dto/tonedto';
import { BaseContext } from '../../../../utils/basecontext';
import { ToneProcessorFactory } from '../../../../core/processorfactory/toneprocessorfactory';
import { BuyMusicChannelDtoImpl } from '../../../../core/dto/buymusicchannel/buymusicchanneldto';
import { BuyMusicChannelResponse } from '../../../../core/api/wishlist/buymusicchannel/buymusicchannelresponse';
import { BuyMusicChannelRequestImpl } from '../../../../core/api/wishlist/buymusicchannel/buymusicchannelrequest';
import { SendOTPDto } from 'src/com/sixdee/crbtportal/core/dto/otp/sendotp/sendotpdto';
import { GenerateOTPResponse } from 'src/com/sixdee/crbtportal/core/api/otp/generateotp/generateotpresponse';
import { GenerateOTPDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/otp/generateotp/generateotpdto';
import { GenerateOTPRequestImpl } from 'src/com/sixdee/crbtportal/core/api/otp/generateotp/generateotprequest';

export interface BuyToneAPIModel extends APIModel 
{
    buyTone(buyToneDto: BuyToneDto): void;
    buyMusicChannelAPI(buyToneDto: BuyToneDto): void;
    getTonePrice(toneDto: ToneDto): void;
    getOTP(createAccountOtpDto: SendOTPDto): void ;
    getTonePriceNonLoggedInuser(giftDto:BuyToneDto): void;

}

export class BuyToneAPIModelImpl extends APIModelImpl implements BuyToneAPIModel 
{
    private toneProcessor: ToneProcessorFactory;
    constructor(applicationContext: BaseContext, apiModelHandler: APIModelHandler) 
    {
        super(applicationContext, apiModelHandler);
        this.toneProcessor = this.getAPIProcesssorFactory().getToneProcessorFactory();
    }

    getOTP(createAccountOtpDto: SendOTPDto): void 
    {
      let generateOtp = new GenerateOTPDtoImpl();
      generateOtp.setMsisdn(createAccountOtpDto.getMsisdn());

        this.getContext().getAPIProcessorFactory().getLoginAPIProcessorFactory().generateOTP()
                .success((generateOTPResponse : GenerateOTPResponse)=>
                {
                    this.getAPIModelHandler().onSuccess(generateOTPResponse.getAPIFeature(), 
                    generateOTPResponse.getDescription(), generateOTPResponse);
                })
                .failure((generateOTPResponse : GenerateOTPResponse)=>
                {
                    this.getAPIModelHandler().onFailure(generateOTPResponse.getAPIFeature(), 
                         generateOTPResponse.getDescription(), generateOTPResponse);

                }).execute(new GenerateOTPRequestImpl(generateOtp));
    }
    buyTone(buyToneDto: BuyToneDto): void 
    {
        this.toneProcessor.getBuyToneAPIProcessor()
        .success((buyResponse : BuyToneResponse)=>
         {
            this.getAPIModelHandler().onSuccess(buyResponse.getAPIFeature(), 
            buyResponse.getDescription(), buyResponse);
         })
       .failure((buyResponse : BuyToneResponse)=>
       {
           this.getAPIModelHandler().onFailure(buyResponse.getAPIFeature(), 
           buyResponse.getDescription(), buyResponse);
         })
       .execute(new BuyToneRequestImpl(buyToneDto));
    }

    getTonePrice(toneDto: ToneDto): void 
    {
      console.log("get tone price");
      
        let getTonePriceDto =  new GetTonePriceDtoImpl();
        getTonePriceDto.setLanguage(this.getContext().getUserContext().getLanguage());
        getTonePriceDto.setServiceId("1");
        getTonePriceDto.setAPartyMsisdn(this.getContext().getUserContext().getMsisdn());
        getTonePriceDto.setToneId(toneDto.getId());
        getTonePriceDto.setValidationIdentifier("3");
        getTonePriceDto.setChannelId(this.getContext().getUserContext().getChannelId());

        this.toneProcessor.getGetTonePriceAPIProcessor()
        .success((getTonePriceResponse : GetTonePriceResponse)=>
         {
            this.getAPIModelHandler().onSuccess(getTonePriceResponse.getAPIFeature(), 
            getTonePriceResponse.getDescription(), getTonePriceResponse.getGetTonePriceDto().getToneDetailsList()[0]);
         })
       .failure((getTonePriceResponse : GetTonePriceResponse)=>
       {
           this.getAPIModelHandler().onFailure(getTonePriceResponse.getAPIFeature(), 
           getTonePriceResponse.getDescription(), getTonePriceResponse);
         })
       .execute(new GetTonePriceRequestImpl(getTonePriceDto));
    }

    getTonePriceNonLoggedInuser(giftDto:BuyToneDto): void 
    {
      console.log("------tigerchanneld"+this.getContext().getUserContext().getChannelId());
        let getTonePriceDto =  new GetTonePriceDtoImpl();
        getTonePriceDto.setLanguage(this.getContext().getUserContext().getLanguage());
        getTonePriceDto.setServiceId("1");
        getTonePriceDto.setAPartyMsisdn(giftDto.getMsisdn());
        getTonePriceDto.setToneId(giftDto.getToneId());
        getTonePriceDto.setValidationIdentifier("3");
        getTonePriceDto.setChannelId(this.getContext().getUserContext().getChannelId());

        this.toneProcessor.getGetTonePriceAPIProcessorNonLoggedInUser()
        .success((getTonePriceResponse : GetTonePriceResponse)=>
         {
            this.getAPIModelHandler().onSuccess(getTonePriceResponse.getAPIFeature(), 
            giftDto.getMsisdn(), getTonePriceResponse.getGetTonePriceDto().getToneDetailsList()[0]);
         })
       .failure((getTonePriceResponse : GetTonePriceResponse)=>
       {
           this.getAPIModelHandler().onFailure(getTonePriceResponse.getAPIFeature(), 
           getTonePriceResponse.getDescription(), getTonePriceResponse);
         })
       .execute(new GetTonePriceRequestImpl(getTonePriceDto));
    }

    buyMusicChannelAPI(buyToneDto: BuyToneDto): void 
     { 
             console.log("buyMusicChannelAPI() invoked ##########BUY MUSIC CHANNEL ###############");
             let buyMusicChannelDto = new BuyMusicChannelDtoImpl();
             buyMusicChannelDto.setServiceId("7");
             buyMusicChannelDto.setAPartyMsisdn(this.getContext().getUserContext().getMsisdn());
             buyMusicChannelDto.setToneId(+buyToneDto.getToneId());
             buyMusicChannelDto.setLanguage(this.getContext().getUserContext().getLanguage());
             buyMusicChannelDto.setPriority("0");
             buyMusicChannelDto.setPaymentMode("2");
    
             this.getAPIProcesssorFactory().getToneProcessorFactory()
             .getBuyMusicChannel()
             .success((buyMusicChannelResponse: BuyMusicChannelResponse)=>
             {
                 console.log("getMusicBoxContentsAPI success ###############BUY MUSIC CHANNEL#################");
                 this.getAPIModelHandler().onSuccess(buyMusicChannelResponse.getAPIFeature(), 
                 buyMusicChannelResponse.getDescription(), buyMusicChannelResponse);
              })
             .failure((buyMusicChannelResponse: BuyMusicChannelResponse)=>
              {
                this.getAPIModelHandler().onFailure(buyMusicChannelResponse.getAPIFeature(), 
                buyMusicChannelResponse.getDescription(), undefined);
              })
             .execute(new BuyMusicChannelRequestImpl(buyMusicChannelDto));
     } 
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/popup/buytone/buytoneapimodel.tsx